export const getRoundBarYValue = (number: number) => {
  if (number < 10) {
    return number
  }
  if (number < 100) {
    return Math.round(number / 10) * 10
  }
  if (number < 1000) {
    return Math.round(number / 100) * 100
  }
  if (number < 10000) {
    return Math.round(number / 1000) * 1000
  }
  return Math.round(number / 10000) * 10000
}
